﻿module Sm.UI.Components.Menu

open Fable.React
open Fable.React.Props
open MobF.React

open Sm.UI
open Sm.UI.Form
open Sm.UI.Menu
open Sm.UI.Components.TextEdit

type Props = {
    Menu: Menu.Type
}

[<ObserverComponent>]
let MenuView (props: Props) =
    let m = props.Menu
    let s = m.State
    let c = m.Computed

    let classList = renderClassList [
        Append "tool"
        Append "app-menu"
        Append "is-feature"
        Toggle ("is-down", s.IsOpen)
        Toggle ("is-interactive", s.Input.IsNone)
    ]

    fragment [] [
        let toggleMenu _ =
            if s.IsOpen then m.Post Close
            else m.Post Open

        let closeMenu _ =
            m.Post Close

        if s.IsOpen then
            let maskClass = renderClassList [
                Toggle ("opaque", s.Input.IsSome)
            ]
            div [Id "modal-mask"; Class maskClass; OnClick closeMenu] []

        div [Class classList; OnClick toggleMenu] [
            iconFor Logo []

            if s.IsOpen then
                ul [Class "menu"; OnClick closeMenu] [
                    for item in c.Items do
                        let itemClass =
                            match item with
                            | Separator -> "is-separator"
                            | Status _ -> "is-status"
                            | Header _ -> "is-header"
                            | Action _ -> "is-action"
                            | ModalInput _ -> "is-modal-input"

                        let handler _ =
                            match s.Input, item with
                            | None, Action action -> m.Post (Handle action.Action)
                            | _ -> ()

                        li [Class itemClass; OnClick handler] [
                            match item with
                            | Separator ->
                                hr []

                            | Header s ->
                                label [] [str s]

                            | Status (text, icon) ->
                                match icon with
                                | Some icon -> iconFor icon [Class "icon"]
                                | None -> nothing

                                label [] [str text]

                            | Action x ->
                                match x.Icon with
                                | Some icon -> iconFor icon [Class "icon"]
                                | None -> nothing

                                label [] [str x.Label]

                            | ModalInput (action, input) ->
                                div [Class "header"] [
                                    match action.Icon with
                                    | Some icon -> iconFor icon [Class "icon"]
                                    | None -> nothing

                                    label [] [str action.Label]
                                ]
                                TextEdit { Input = input; ShowControls = true; ValidationDisplay = Subtle }
                        ]
                ]
        ]
    ]
